import { render, staticRenderFns } from "./LoginAdminByTokenPage.vue?vue&type=template&id=532849dc"
import script from "./LoginAdminByTokenPage.vue?vue&type=script&lang=js"
export * from "./LoginAdminByTokenPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports